import React, { useCallback } from 'react';
import { observer } from 'mobx-react';
import { FormWrapper } from 'ksnm-common-ui/lib/Form/FormWrapper';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import { Modal } from 'ksnm-common-ui/lib/Modal';

import { cmApi } from '@src/api';
import { controlApplicabilityStore } from '@stores/dictionaryStores/controlApplicabilityStore/controlApplicabilityStore';
import { preloaderStore } from '@stores/preloaderStore';

import { Form } from './Form';

import styles from './TemplateModal.module.scss';

export const TemplateModal = observer(() => {
  const { templateModalOpen, toggleTemplateModal, fetch } = controlApplicabilityStore;

  const onSubmit = useCallback(
    async (value) => {
      preloaderStore.preloader(true);
      const promises = value.controlVersions.map((item) =>
        cmApi.controlApplicability.addControlApplicability({
          ctrlVersCode: item.ctrlVersCode,
          orgCode: value.organization,
          repGroupCode: value.reportGroup,
          stepNums: [],
        }),
      );

      await Promise.all(promises);
      preloaderStore.preloader(false);
      fetch();
      toggleTemplateModal();
    },
    [toggleTemplateModal, fetch],
  );

  return (
    <Modal
      open={templateModalOpen}
      className={styles.modal}
      centered
      footer={null}
      onCancel={toggleTemplateModal}
      width={1200}
      closeIcon={<Icon name="close" noFill height={24} />}
      destroyOnClose
    >
      <div className={styles.container}>
        <h1 className={styles.title}>Добавить шаблоны</h1>

        <FormWrapper onSubmit={onSubmit} layout="vertical" className={styles.form}>
          <Form />
        </FormWrapper>
      </div>
    </Modal>
  );
});
